/**
 * Description: 输入提示,类型有:文本 订单选择器
 * User: 乐弋
 * Date: 17/02/20
 * Copyright(c) 2017 Taobao.com
 */


import $ from '@ali/tarzan-zepto';
import events from 'events';
import tpl from './tpl.html';

require('./style.scss');

export default class InputTip extends events {

  constructor(text, $wrap) {
    super();
    this.showed = false;
    let q = '';
    if (/\\u(\S{4})/g.test(text)) {
      text.replace(/\\u(\S{4})/g, (a, b) => {
        q += String.fromCharCode(parseInt(b, 16));
      });
    } else {
      q = text;
    }
    this.text = q;
    this.$node = $(tpl.render({
      text: q,
    }));
    $wrap.append(this.$node);
    this.__bindEvent(this.$node);
  }

  hideTip() {
    this.$node.hide();
  }

  showTip() {
    const self = this;
    if (!this.showed) {
      this.$node.show();
      this.showed = true;
      setTimeout(() => {
        self.hideTip();
      }, 6000);
    }
  }

  __bindEvent($node) {
    $node.on('tap', () => {
      this.emit('send', { text: this.text });
      this.hideTip();
    });
  }

}



// WEBPACK FOOTER //
// ./src/component/view/footer/inputtip/index.js